import { z } from 'zod';

// Client-safe public env. Import this from anywhere — server or client.
// Server-only secrets live in lib/env.server.ts.
//
// Next.js inlines `process.env.NEXT_PUBLIC_*` at build time for the client
// bundle, so reading them here works in both environments.

const publicEnvSchema = z.object({
  NEXT_PUBLIC_API_URL: z.string().url(),
  NEXT_PUBLIC_VAPID_PUBLIC_KEY: z.string().min(1).optional(),
});

export const publicEnv = publicEnvSchema.parse({
  NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
  NEXT_PUBLIC_VAPID_PUBLIC_KEY: process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY,
});
